const UPDATE_ON_BOARDING = 'UPDATE_ON_BOARDING';

// eslint-disable-next-line
export const updateOnBoarding = data => (dispatch) => {
  return dispatch({
    type: UPDATE_ON_BOARDING,
    data,
  });
};
